<template>
  <el-card 
    size="small" 
    class="mb-3"
    :class="isDisabled ? 'bg-secondary' : codeState.data?.id === item?.id ? 'bg-primary-light' : 'bg-light cursor-pointer'"
    @click="onClickPromo"
  >
    <template #header>
      <div class="d-flex justify-content-between">
        <div>
          <span v-if="item?.promotion?.title_translations" class="text-primary mr-2">
            {{ dt(item.promotion.title_translations) }}
          </span>
          <span v-if="item?.promotion?.codes" class="text-muted">
            ({{ item.promotion.codes[0] }})
          </span>
        </div>
        <el-tag v-if="item?.promotion?.condition_scope == 'subtotal'" effect="dark">{{ t("promotions.subtotal") }}</el-tag>
        <el-tag v-else-if="item?.promotion?.condition_scope == 'categories'" effect="dark">{{ t("promotions.categories") }}</el-tag>
        <el-tag v-else-if="item?.promotion?.condition_scope == 'products'" effect="dark">{{ t("promotions.products") }}</el-tag>
      </div>
    </template>
    <div class="d-flex justify-content-between">
      <div>
        <div v-if="item?.promotion?.conditions && item.promotion.conditions.length">
          {{ t("promotions.lowAmount") }}: 
          {{ codeState.currency }}
          {{ currencyFormat(item.promotion.conditions[0].min_amount | 0) }}
        </div>
        <div v-if="!!item?.promotion?.member_use_count">
          {{ t("promotions.memberOnly") }}: 
          {{ currencyFormat(item.promotion.member_use_count | 0) }}
        </div>
      </div>
      <div class="text-right">
        <div v-if="item?.promotion?.conditions && item.promotion.conditions.length">
          {{ t("promotions.discount") }}: 
          <span v-if="item?.promotion?.discount_type == 'amount'">
            {{ codeState.currency }}
            {{ currencyFormat(item.promotion.conditions[0].discount_amount | 0) }}
          </span>
          <span v-else-if="item?.promotion?.discount_type == 'percentage'">
            {{ currencyFormat(item.promotion.conditions[0].discount_percentage | 0) }}%
          </span>
          <span v-if="item?.promotion?.discount_type == 'percentage' && !!item.promotion.conditions[0].discount_amount">
            ({{ t("promotions.maxAmount") }} 
            {{ codeState.currency }}
            {{ currencyFormat(item.promotion.conditions[0].discount_amount | 0) }})
          </span>
        </div>
        <div v-if="item?.promotion?.max_use_count" class="text-muted">
          {{ t("promotions.timesLeft") }}: 
          {{ currencyFormat(item.promotion.max_use_count - item.promotion.use_count | 0) }}
        </div>
        <div v-if="item?.promotion?.ended_at">
          {{ t("bankInfo.expireDate") }}: 
          {{ dateFormat(item.promotion.ended_at) }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { breakpoint, currencyFormat, checkValidCurrencyStr, dateFormat, dataTranslations as dt } from "../../../utils"
const props = defineProps({
  item: Object,
  codeState: Object,
})
const emit = defineEmits(['click'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)
const isDisabled = computed(() => props.codeState.params.status == "past" || !props.item.is_valid)

const onClickPromo = () => {
  emit("click", props.item)
}

</script>
